
import { defineComponent } from 'vue'
import NewMemberForm from '@/components/free-subscriptions/forms/new-member.vue'
import { MemberProfile } from '@/modules/members/types'

export default defineComponent({
    name: 'free-subscriptions-new-member-dialog',
    emits: ['pickAddedMember'],
    components: { NewMemberForm },
    setup (props, { emit }) {
        function pickAddedMember (memberModel: MemberProfile) {
            emit('pickAddedMember', memberModel)
        }
        return {
            pickAddedMember
        }
    }
})
